import { useSelector } from "react-redux"

import { Routes, Route, useParams } from "react-router"

import { RootState } from "../store"

import { HomePage } from "../pages/HomePage"
import { AdministracionPage } from "../pages/admin/AdministracionPage"

import { NotFoundPage } from "../pages/auth/NotFoundPage"

import { ApiKeysPage } from "../pages/admin/ApiKeysPage"
import { UsuariosPage } from "../pages/admin/UsuariosPage"
import { ReasignacionCancelacionPage } from "../pages/admin/ReasignacionCancelacionPage"
import { AdministracionDocumentosPage } from "../pages/admin/AdministracionDocumentosPage"

import { DemandaInicialPage } from "../pages/comun/demandaInicial/DemandaInicialPage"
import { PromocionPage } from "../pages/comun/promocion/PromocionPage"
import { ExhortoRecibidoPage } from "../pages/comun/exhortoRecibido/ExhortoRecibidoPage"
import { AmparoPage } from "../pages/comun/amparo/AmparoPage"

import { EstatusPage } from "../pages/catalogos/EstatusPage"
import { TipoUsuarioPage } from "../pages/catalogos/TipoUsuarioPage"
import { AsentamientoPage } from "../pages/catalogos/AsentamientoPage"
import { AutoridadAmparoPage } from "../pages/catalogos/AutoridadAmparoPage"
import { AutoridadExhortoPage } from "../pages/catalogos/AutoridadExhortoPage"
import { AutoridadPage } from "../pages/catalogos/AutoridadPage"
import { CiudadPage } from "../pages/catalogos/CiudadPage"
import { DistritoJudicialPage } from "../pages/catalogos/DistritoJudicialPage"
import { EstadoPage } from "../pages/catalogos/EstadoPage"
import { MateriaPage } from "../pages/catalogos/MateriaPage"
import { MunicipioPage } from "../pages/catalogos/MunicipioPage"
import { PaisPage } from "../pages/catalogos/PaisPage"
import { PuestoPage } from "../pages/catalogos/PuestoPage"
import { RolPage } from "../pages/catalogos/RolPage"
import { SexoPage } from "../pages/catalogos/SexoPage"
import { TipoAmparoPage } from "../pages/catalogos/TipoAmparoPage"
import { TipoAnexoPage } from "../pages/catalogos/TipoAnexoPage"
import { TipoAsentamientoPage } from "../pages/catalogos/TipoAsentamientoPage"
import { TipoCalificacionPage } from "../pages/catalogos/TipoCalificacionPage"
import { TipoDomicilioPage } from "../pages/catalogos/TipoDomicilioPage"
import { TipoFormatoPage } from "../pages/catalogos/TipoFormatoPage"
import { TipoJuicioPage } from "../pages/catalogos/TipoJuicioPage"
import { TipoJuicioMateriaPage } from "../pages/catalogos/TipoJuicioMateriaPage"
import { TipoPartePage } from "../pages/catalogos/TipoPartePage"
import { TipoPersonaPage } from "../pages/catalogos/TipoPersonaPage"
import { TipoConceptoJuicioPage } from "../pages/catalogos/TipoConceptoJuicioPage"
import { TipoConceptoPage } from "../pages/catalogos/TipoConceptoPage"
import { ZonaPage } from "../pages/catalogos/ZonaPage"
import { TipoPromocionPage } from "../pages/catalogos/TipoPromocionPage"
import { TipoSesionPage } from "../pages/catalogos/TipoSesionPage"
import { TipoTramitePage } from "../pages/catalogos/TipoTramitePage"

import { TramitesRecibidosPage } from "../pages/consultas/TramitesRecibidosPage"
import { GenerarListadoEntregaPage } from "../pages/comun/listado-entrega/GenerarListadoEntregaPage"
import { ConsultarListadoEntregaPage } from "../pages/comun/listado-entrega/ConsultarListadoEntregaPage"

const WithKey = ({ Component }: { Component: React.ComponentType }) => {

    const { Id } = useParams();

    return <Component key={ Id } />;
};

export const OficialiaRoutes = () => {

    const { administrador, token } = useSelector( ( state: RootState ) => state.auth );

    return (

        <Routes>

            {
                administrador
                ?
                    <>
                    
                        <Route path="/" element={ <AdministracionPage /> } />   
                        
                        <Route path="/administracion/usuarios/" element={ <UsuariosPage/> } />   
            
                        <Route path="/administracion/apikeys/" element={ <ApiKeysPage/> } />    
            
                        <Route path="/administracion/apikeys/" element={ <ApiKeysPage/> } />      

                        <Route path="/administracion/reasignacion-cancelacion/" element={ <ReasignacionCancelacionPage/> } />       
                                    
                        <Route path="/administracion/administracion-documentos/" element={ <AdministracionDocumentosPage/> } />                   

                        <Route path="/administracion/catalogos/asentamiento/" element={ <AsentamientoPage/> } />       
                        
                        <Route path="/administracion/catalogos/autoridad-amparo/" element={ <AutoridadAmparoPage /> } />       
                        
                        <Route path="/administracion/catalogos/autoridad-exhorto/" element={ <AutoridadExhortoPage /> } />       
                        
                        <Route path="/administracion/catalogos/autoridad/" element={ <AutoridadPage /> } />       
                        
                        <Route path="/administracion/catalogos/ciudad/" element={ <CiudadPage /> } />       
                        
                        <Route path="/administracion/catalogos/distrito-judicial/" element={ <DistritoJudicialPage /> } />       
                        
                        <Route path="/administracion/catalogos/estado/" element={ <EstadoPage/> } />       
                        
                        <Route path="/administracion/catalogos/estatus/" element={ <EstatusPage/> } />       
                        
                        <Route path="/administracion/catalogos/materia/" element={ <MateriaPage/> } />       
                        
                        <Route path="/administracion/catalogos/municipio/" element={ <MunicipioPage /> } />       
                        
                        <Route path="/administracion/catalogos/pais/" element={ <PaisPage /> } />       

                        <Route path="/administracion/catalogos/puesto/" element={ <PuestoPage /> } />     
                                           
                        <Route path="/administracion/catalogos/rol/" element={ <RolPage /> } />                        
                        
                        <Route path="/administracion/catalogos/sexo/" element={ <SexoPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-amparo/" element={ <TipoAmparoPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-anexo/" element={ <TipoAnexoPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-asentamiento/" element={ <TipoAsentamientoPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-calificacion/" element={ <TipoCalificacionPage /> } />    

                        <Route path="/administracion/catalogos/tipo-domicilio/" element={ <TipoDomicilioPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-formato/" element={ <TipoFormatoPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-juicio/" element={ <TipoJuicioPage /> } />    

                        <Route path="/administracion/catalogos/tipo-juicio-materia/" element={ <TipoJuicioMateriaPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-parte/" element={ <TipoPartePage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-persona/" element={ <TipoPersonaPage /> } />      

                        <Route path="/administracion/catalogos/tipo-concepto-juicio/" element={ <TipoConceptoJuicioPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-concepto/" element={ <TipoConceptoPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-promocion/" element={ <TipoPromocionPage /> } />      
                        
                        <Route path="/administracion/catalogos/tipo-sesion/" element={ <TipoSesionPage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-tramite/" element={ <TipoTramitePage /> } />                        
                        
                        <Route path="/administracion/catalogos/tipo-usuario/" element={ <TipoUsuarioPage/> } />                        
                        
                        <Route path="/administracion/catalogos/zona/" element={ <ZonaPage /> } />         

                        <Route path="/consultas/tramites-recibidos/" element={ <TramitesRecibidosPage /> } />                              

                    </>
                :
                
                    <>
                    
                        <Route path="/" element={ <HomePage /> } />

                        <Route path="/recepcion/demanda-inicial/:Id" element={ <WithKey Component={ DemandaInicialPage } /> } />

                        <Route path="/recepcion/promocion/:Id" element={ <WithKey Component={ PromocionPage } /> } />

                        <Route path="/recepcion/exhorto-recibido/:Id" element={ <WithKey Component={ ExhortoRecibidoPage } /> } />

                        <Route path="/recepcion/amparo/:Id" element={ <WithKey Component={ AmparoPage } /> } />

                        <Route path="/listado-entrega/generar/:Id" element={ <WithKey Component={ GenerarListadoEntregaPage } /> } />
                        
                        <Route path="/listado-entrega/consultar/" element={ <ConsultarListadoEntregaPage /> } />

                        <Route path="/consultas/tramites-recibidos/" element={ <TramitesRecibidosPage /> } />    

                        <Route path="/administracion/catalogos/autoridad-exhorto/" element={ <AutoridadExhortoPage /> } />  

                        <Route path="/administracion/catalogos/tipo-anexo/" element={ <TipoAnexoPage /> } />  
                        
                        <Route path="/administracion/catalogos/tipo-formato/" element={ <TipoFormatoPage /> } />   

                    </>
            }

            { token && <Route path="*" element={ <NotFoundPage /> } /> }                       

        </Routes>        
    
    )
}